var map = {
	"./1PostGame.jpeg": 2872,
	"./2PostModularKits.jpg": 5393,
	"./3Controller.jpg": 2197,
	"./4Curvemancer.jpg": 839,
	"./5EvergrowRework.jpg": 7058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7351;